<template>
    <div class="stack mb-5">
        <div class="m-auto text-left control-width border shadow add-rounded p-4">
            <h5 class="mb-3 font-weight-bold kova-text">How many years of experience do you have as a software developer with
                your core tech stack?</h5>            
                <a-input-number class="" size="large" placeholder="0"/> 
                <br />
                <h5 class="mt-4 font-weight-bold kova-text">List out other tech stacks where you have a high-level expertise and number of
                    projects completed</h5>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mt-3">
                            <a-select
                                mode="multiple" class="w-100" @change="handleChange" size="large" placeholder="Please select">
                                <a-select-option v-for="stack in stacks" :key="stack"
                                >{{stack}}</a-select-option
                                >
                            </a-select>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-3">
                            <a-input-number class=" w-100" size="large" :min="0" :max="10" placeholder="number of projects you have completed" @change="displayLink"/>
                        </div>
                        
                    </div> 
                    <div :key="n" v-for="n in numLink">
                        <a-input class="mt-3 w-75" addonBefore="https://" placeholder="add project link" /><br/>
                    </div>
                
                <h5 class="mt-4 font-weight-bold kova-text">Github profile link</h5> 
                <a-input class="w-50" size="large" placeholder="https://github.com/username"/> 
                
                <h5 class="mt-4 font-weight-bold kova-text">Select your hourly rates</h5>
                <label for="opt1" class="radio text-left">
                    <input type="radio" name="rdo" id="opt1" class="hidden" value="devone" v-model="duration"/>
                    <span class="label"></span>$10 - $20/hr (Junior)
                </label><br />
                
                <label for="opt2" class="radio text-left">
                    <input type="radio" name="rdo" id="opt2" class="hidden" value="devtwo" v-model="duration" />
                    <span class="label"></span>$15 - $40/hr (Intermediate)
                </label><br />

                <label for="opt3" class="radio text-left">
                    <input type="radio" name="rdo" id="opt3" class="hidden" value="devthree" v-model="duration"/>
                    <span class="label"></span>$25- $60/hr (Senior)
                </label><br />
<!-- 
                <label for="opt4" class="radio text-left">
                    <input type="radio" name="rdo" id="opt4" class="hidden" value="not-certain" v-model="duration" />
                    <span class="label"></span>Fixed price per month?
                </label> -->
            <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                <div class="row">
                    <div class="col text-left">
                        <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                    </div>
                    <div class="col text-right">
                         <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                    </div>
                </div>
            </div>
            
        </div> 
 </div>
</template>
<script>
export default {
    name: 'stack',
    data(){
        return {
            stacks: [
                'Front-end', 'Back-end', 'Full Stack', 'Android', 'IOS', 'CyberSecurity',
                'A.I', 'Blockchain', 'Integration', 'DApp', 'DevOps', 'Others'],
            numLink: 0
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1);
        },
        next(){
            this.$router.push('experience');
        },
        displayLink(value){
            this.numLink = value;
        }
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}

@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>